/*
 * @@Description: 筛选
 * @@Author: MuYang
 * @Date: 2021-08-30 10:18:25
 * @LastEditTime: 2021-11-10 15:49:31
 */
// TODO 整体带优化
import { cellForced, SELECT_CONFIG } from '../util/config'
import { parseString } from '../util'
import { isFunction } from 'lodash-es'

function isSameColumn (newCol, oldCol) {
  if (newCol.length !== oldCol) {
    return false
  }
  return newCol.every(
    (curItem, index) =>
      curItem.key === oldCol[index].key && curItem.type === oldCol[index].type
  )
}

let _getRowKey = rowKey => {
  let keyFn = rowKey
  if (typeof rowKey !== 'function') {
    keyFn = record => parseString(rowKey, record)
  }
  return function (record, index) {
    let key = keyFn(record)
    return key === undefined || key === '' ? index : key
  }
}

function getKeysMap (data = [], getRowKeyFn) {
  const obj = {}
  data.forEach((item, i) => {
    obj[getRowKeyFn(item, i)] = item
  })
  return obj
}

class SelectStore {
  constructor (options) {
    this.rowSelection = options.rowSelection || {}
    this.selectDataSource = options.dataSource
    this.$createElement = options.createElement
    this.rowKey = options.rowKey
    this.cacheColumns = []
    this.selectionMap = {}
    this.getRowKey = _getRowKey(options.rowKey)
    this.init()
  }

  // 全选状态
  get isAllSelected () {
    if (this.isAllDisabled) return false
    if (
      this.rowSelection.selectedRows.length <
      this.selectDataSource.filter(item => !item.groupTitle).length
    ) {
      return false
    }
    return this.selectDataSource.every((row, index) =>
      this.getRowSelectState(row, index)
    )
  }

  // 禁止全选
  get isAllDisabled () {
    return (
      this.selectDataSource.length === 0 ||
      this.selectDataSource.every(
        (row, index) => !this.isRowSelectable(row, index)
      )
    )
  }

  // 图标样式
  get indeterminate () {
    return this.rowSelection.selectedRows.length > 0 && !this.isAllSelected
  }

  // 单选状态
  get radioSelect () {
    return this.rowSelection.selectedRows[0]
  }

  // 跨页存储
  get reserveSelection () {
    return this.selectColumn?.reserveSelection
  }

  // 初始化
  init () {
    const { rowSelection } = this
    if (
      !rowSelection.selectedRows ||
      !Array.isArray(rowSelection.selectedRows)
    ) {
      rowSelection.selectedRows = []
    }
    this._bindThis()

    this.CONFIG = {
      checkbox: {
        toggleRowSelection: this.togglerowBoxSelected.bind(this),
        renderCell: cellForced.selection.renderCheckboxCell.bind(this),
        renderHeader: cellForced.selection.renderHeader.bind(
          this,
          this.$createElement,
          { toggleAllSelection: this.toggleAllSelection }
        ),
        valueFn: this.getRowSelectState
      },
      radio: {
        renderCell: cellForced.selection.renderRadioCell.bind(this),
        toggleRowSelection: this.toggleRadiorowSelected.bind(this),
        valueFn: this.getRowKey
      }
    }
  }

  // 当前行是否可以勾选
  isRowSelectable (row, index) {
    const selectable = this.selectColumn?.selectable
    return selectable ? selectable(row, index) : true
  }

  _bindThis () {
    const bindArr = ['update', 'getRowSelectState', 'updateData', 'toggleAllSelection']
    bindArr.forEach(key => {
      this[key] = this[key].bind(this)
    })
  }

  // 当前行选中状态
  getRowSelectState (row, index) {
    return this.rowSelection.selectedRows.includes(this.getRowKey(row, index))
  }

  // 全选
  toggleAllSelection () {
    const { rowSelection, isAllSelected, indeterminate, reserveSelection, selectionMap } = this
    reserveSelection ? this.cleanSelection(true) : this.clearSelection()
    if (!isAllSelected && (!indeterminate || reserveSelection)) {
      this.selectDataSource.forEach((row, index) => {
        if (!this.isRowSelectable(row, index)) return
        let key = this.getRowKey(row, index)
        rowSelection.selectedRows.push(key)
        selectionMap[key] = row
      })
    }
    this._selectChange()
  }

  // 多选模式切换行选中状态
  togglerowBoxSelected (row, rowIndex, selectState) {
    if (!row) {
      console.log('当前项row不存在')
      return
    }
    const { rowSelection } = this
    const curRowKey = this.getRowKey(row, rowIndex)
    const index = rowSelection.selectedRows.indexOf(curRowKey)
    // 如果设置了当前状态 则不处理
    if (
      (selectState === true && index !== -1) ||
      (selectState === false && index === -1)
    ) {
      return
    }
    index === -1
      ? rowSelection.selectedRows.push(curRowKey)
      : rowSelection.selectedRows.splice(index, 1)
    this.cacheSelectionMap(row, curRowKey, index === -1)
    this._selectChange()
  }

  // 存储
  cacheSelectionMap (row, curRowKey, isAdd) {
    const { selectionMap } = this
    if (isAdd) {
      selectionMap[curRowKey] = row
    } else {
      delete selectionMap[curRowKey]
    }
  }

  // 单选
  toggleRadiorowSelected (row, rowIndex) {
    const { rowSelection, selectionMap } = this
    const curRowKey = this.getRowKey(row, rowIndex)
    rowSelection.selectedRows.splice(0, 1, curRowKey)
    selectionMap[curRowKey] = row
    this._selectChange()
  }

  // 调用外部筛选
  _selectChange () {
    const {
      selectionMap,
      rowSelection: { selectedRows, selectionChange }
    } = this
    const selectArr = selectedRows.map(key => selectionMap[key])
    selectionChange && selectionChange(selectArr, selectedRows)
  }

  // 渲染
  renderRowSelection (columns, selectColumn) {
    if (isSameColumn(columns, this.cacheColumns)) {
      return this.cacheColumns
    }
    const { $createElement, rowSelection } = this
    let selectionColumn = Object.assign(
      {},
      SELECT_CONFIG,
      rowSelection,
      selectColumn
    )
    const {
      toggleRowSelection,
      renderCell,
      renderHeader,
      valueFn
    } = this.CONFIG[selectionColumn.selectType]
    this.selectColumn = selectionColumn
    this.toggleRowSelection = toggleRowSelection

    selectionColumn.title = selectionColumn.title || renderHeader

    selectionColumn.customRender = ({ row, $index: rowIndex }) => {
      return renderCell($createElement, {
        row,
        toggleRowSelection: () => {
          toggleRowSelection(row, rowIndex)
        },
        tip: isFunction(selectionColumn.selectTip) ? selectionColumn.selectTip(row) : selectionColumn.selectTip,
        disabled: isFunction(selectionColumn.selectable)
          ? !selectionColumn.selectable(row, rowIndex)
          : false,
        value: valueFn(row, rowIndex)
        // rowSelection.selectedRows.includes(getRowKey(row, rowIndex))
      })
    }
    // // 当前不是单选
    if (
      columns.some(column => column.fixed === 'left' || column.fixed === true)
    ) {
      selectionColumn.fixed = 'left'
    }
    columns.unshift(selectionColumn)
    this.cacheColumns = columns
    this.rowSelection.selectionChange = selectionColumn.selectionChange
    return columns
  }

  // 更新默认值
  update (val) {
    if (this.rowSelection.selectedRows !== val.selectedRows) {
      this.rowSelection.selectedRows = val.selectedRows || []
    }
  }

  // 更新
  updateData (val) {
    this.updateSelect(this.selectDataSource !== val)
    this.selectDataSource = val
  }

  // 更新选中状态
  updateSelect (dataInstanceChanged) {
    const { selectColumn, rowKey } = this
    if (selectColumn?.reserveSelection) {
      if (!rowKey) throw new Error('[ElTable] prop row-key is required')
      this.updateSelectionByRowKey()
    } else {
      dataInstanceChanged ? this.clearSelection() : this.cleanSelection()
    }
  }

  // 清空
  clearSelection () {
    const { rowSelection } = this
    if (rowSelection.selectedRows.length > 0) {
      rowSelection.selectedRows.splice(0, rowSelection.selectedRows.length)
    }
  }

  // 局部更新
  cleanSelection (flag = false) {
    const { rowSelection, selectDataSource, selectionMap } = this
    if (rowSelection.selectedRows.length > 0) {
      const dataMap = getKeysMap(selectDataSource, this.getRowKey)
      for (let i = 0; i < rowSelection.selectedRows.length; i++) {
        let key = rowSelection.selectedRows[i]
        if (flag ? dataMap[key] : !dataMap[key]) {
          rowSelection.selectedRows.splice(i, 1)
          delete selectionMap[key]
          i--
        }
      }
      this._selectChange()
    }
  }

  updateSelectionByRowKey () {
    console.log(this.rowSelection.selectedRows)
  }

  // 重置
  resetSelection () {
    const {
      rowSelection: { selectionChange }
    } = this
    this.clearSelection()
    this.selectionMap = {}
    selectionChange && selectionChange([])
  }
}

export default function createdSelected (payload) {
  return new SelectStore(payload)
}
